module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.9882/images/crm-central-place/crm-central-place@3x.svg"